import { EventBasicInformation } from '../../../../contexts/EventContext/types';

export const getCheckAvailabilityWidgetEventId = ({
    waitlistToken,
    basicEventInformation,
}: {
    waitlistToken?: string;
    basicEventInformation: EventBasicInformation;
}) => {
    // If we have a waitlist token, we should use the child event ID
    if (waitlistToken && basicEventInformation.id) {
        return basicEventInformation.id;
    }
    // Otherwise use parent ID for normal timed entry flow
    return basicEventInformation.parentEventId;
};

/**
 * Builds the checkout-external URL with optional query parameters
 * @param baseUrl - The server URL (e.g., serverUrl from context)
 * @param eventId - The event ID
 * @param promoCode - Optional promo code
 * @param waitlistToken - Optional waitlist token
 * @param campaignToken - Optional campaign token
 * @returns The complete checkout-external URL
 */
export const buildCheckoutUrl = (
    baseUrl: string | undefined,
    eventId: string,
    promoCode?: string,
    waitlistToken?: string,
    campaignToken?: string,
): string => {
    let url = `${baseUrl || ''}/checkout-external?eid=${eventId}`;

    if (promoCode) {
        url += `&promo_code=${encodeURIComponent(promoCode)}`;
    }

    if (waitlistToken) {
        url += `&w=${waitlistToken}`;
    }

    if (campaignToken) {
        url += `&mipa=${campaignToken}`;
    }

    return url;
};
